<template>
    <form @submit.prevent="submit" dis>
        <modal width="small">
            <modal-header>Reklamation vom Kunden</modal-header>
            <modal-content>
                <card class="card--minify card--message error " v-if="form.errors.ups">
                    <card-content v-html="form.errors.ups"></card-content>
                </card>

                <form-datepicker id="complaint_at" label="Reklamationsdatum" name="complaint_at"
                                 v-model:date="form.complaint_at" :error="form.errors.complaint_at"/>

                <form-input id="amount" :label="'Stückzahl (max '+maxComplaintQty+' Stück)'" name="amount"
                            v-model="form.amount"
                            :error="form.errors.amount" autocomplete="off"/>

                <form-select id="complaint_reason_id" label="Reklamationsgrund" name="complaint_reason_id"
                             v-model="form.complaint_reason_id" :error="form.errors.complaint_reason_id"
                             :options="complaintReasons"/>

                <form-html id="text" label="Nachricht an Kunden" v-model="form.text" :error="form.errors.text"
                           height="300px"/>

                <form-text id="comment" label="Kommentar" name="comment" v-model="form.comment"
                           :error="form.errors.comment" height="100px"/>

                <form-select id="creator" label="Ersteller" name="creator" v-model="form.creator"
                             :error="form.errors.creator" :options="creatorOptions"/>

                <form-select id="admin_user_id" label="Bearbeitet von" name="admin_user_id" v-model="form.admin_user_id"
                             :error="form.errors.admin_user_id" :options="adminUserOptions"/>

                <form-select id="reason_valid" label="Berechtigt" name="reason_valid" v-model="form.reason_valid"
                             :error="form.errors.reason_valid" :options="reasonValidOptions"/>
                <hr>

                <form-checkbox id="complaint_bill" v-model:checked="form.complaint_bill"
                               option="Retourenschein generieren?"
                               v-if="!clientComplaint"/>

                <form-select id="labels" label="Anzahl UPS Pakete" name="labels" @change="setUps"
                             :error="form.errors.labels" :options="upsLabelOptions" v-model="form.labels"
                             v-if="form.complaint_bill || clientComplaint" :disabled="complaintClosed"/>

                <div v-if="form.complaint_bill || clientComplaint">
                    <form-group v-for="(ups, index) in form.ups" :key="ups.index">
                        <form-input id="ups_0_height" label="Höhe (cm)" name="ups[0][height]" v-model="ups.height"
                                    :error="form.errors[`ups.${index}.height`]" autocomplete="off"/>
                        <form-input id="ups_0_width" label="Breite (cm)" name="ups[0][width]" v-model="ups.width"
                                    :error="form.errors[`ups.${index}.width`]" autocomplete="off"/>
                        <form-input id="ups_0_length" label="Länge (cm)" name="ups[0][length]" v-model="ups.length"
                                    :error="form.errors[`ups.${index}.length`]" autocomplete="off"/>
                        <form-input id="ups_0_weight" label="Gewicht (kg)" name="ups[0][weight]" v-model="ups.weight"
                                    :error="form.errors[`ups.${index}.weight`]" autocomplete="off"/>
                    </form-group>
                </div>

                <form-button type="button" @click="submitComplaintBill" v-if="clientComplaint" class="btn--block" :disabled="complaintClosed"
                             color="secondary">Retourenschein
                    generieren
                </form-button>

                <hr>

                <form-text id="result" label="Ergebnis der Reklamation" name="result" v-model="form.result"
                           :error="form.errors.result" height="100px" v-if="clientComplaint"/>

                <form-button type="button" @click="closeComplaint" v-if="clientComplaint" class="btn--block" color="secondary" :disabled="complaintClosed">Reklamation schließen</form-button>

            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="complaintClosed || form.processing" :class="{'btn--processing': form.processing}">Speichern</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import FormText from '@partfactory/Shared/Form/FormText';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';
import FormHtml from '@partfactory/Shared/Form/FormHtml';
import CardContent from '@partfactory/Shared/Card/CardContent';
import Card from '@partfactory/Shared/Card/Card';

export default {
    name: 'ClientComplaintModal',
    components: {
        Card,
        CardContent,
        FormHtml,
        FormCheckbox,
        FormGroup,
        FormText,
        FormSelect, FormInput, FormDatepicker, FormButton, ModalActions, ModalContent, ModalHeader, Modal
    },
    emit: ['closeDialog'],
    props: {
        clientComplaint: Object,
        askForQuote: Object,
        adminUsers: Object,
    },
    data() {
        let upsLabelOptions = [];
        for (let i = 1; i < 99; i++) {
            upsLabelOptions.push({text: i, value: i});
        }

        if (this.askForQuote?.client_user?.language === 2) {
            this.$language.current = 'en';
        }

        const translated = this.$gettext('<h1>Guten Tag %{name},</h1>' +
            '<p>wir bedauern sehr, dass wir Ihnen Anlass zur Reklamation gegeben haben und Sie nun vermutlich enttäuscht sind.</p>' +
            '<p>Ihre Zufriedenheit liegt uns sehr am Herzen, weshalb wir jede Reklamation sorgfältig prüfen und uns schnellstmöglich wieder bei Ihnen melden.</p>' +
            '<p>Sollten Sie zwischenzeitlich noch Fragen haben, stehen wir Ihnen selbstverständlich gerne persönlich unter der PART FACTORY Telefon-Hotline <a href="+4922739537362">+49 2273 95 373 62</a> zur Verfügung.</p>' +
            '<p>Beste Grüße</p><p>%{admin}, Service Operator PART FACTORY</p>');

        const text = this.$gettextInterpolate(translated, {
            name: this.askForQuote?.client_user?.name,
            pfnumber: this.askForQuote.pfnumber,
            componentUrl: this.$page.props.urls.client_url + '/component/' + this.askForQuote.id,
            admin: this.$page.props.user.name,
        });

        this.$language.current = 'de';

        const currentDate = this.$moment(new Date, 'YYYY-MM-DD').format('YYYY-MM-DD');

        const form = useForm({
            complaint_at: this?.clientComplaint?.complaint_at ? this?.clientComplaint?.complaint_at : currentDate,
            amount: this?.clientComplaint?.amount ? this?.clientComplaint?.amount : null,
            comment: this?.clientComplaint?.comment ? this?.clientComplaint?.comment : null,
            complaint_reason_id: this?.clientComplaint?.complaint_reason_id ? String(this?.clientComplaint?.complaint_reason_id) : null,
            creator: this?.clientComplaint?.creator ? String(this?.clientComplaint?.creator) : String('1'),
            admin_user_id: this?.clientComplaint?.admin_user_id ? this?.clientComplaint?.admin_user_id : this.$page.props.user.id,
            reason_valid: this?.clientComplaint?.reason_valid ? String(this?.clientComplaint?.reason_valid) : String('-1'),
            result: this?.clientComplaint?.result ? this?.clientComplaint?.result : null,
            complaint_bill: null,
            labels: [],
            ups: [],
            text: text,
            closed: null,
        });

        return {upsLabelOptions, form};
    },
    computed: {
        complaintReasons() {
            return this.$page.props.complaintReasons;
        },
        creatorOptions() {
            // Todo: Config
            return [
                {value: 1, text: 'Partfactory'},
                {value: 0, text: 'Kunde'},
            ];
        },
        reasonValidOptions() {
            // Todo: Config
            return [
                {value: -1, text: 'offen'},
                {value: 0, text: 'Nein'},
                {value: 1, text: 'Ja'},
            ];
        },
        adminUserOptions() {
            let adminUserOptions = [];
            this.adminUsers?.forEach(adminUser => {
                adminUserOptions.push({value: adminUser.id, text: adminUser.name});
            });

            return adminUserOptions;
        },
        maxComplaintQty() {
            let maxComplaintQty = 0;

            this.askForQuote?.outgoing_goods_client?.forEach((outgoing) => {
                maxComplaintQty += outgoing.amount;
            });

            this.askForQuote?.client_complaints?.forEach((complaint) => {
                maxComplaintQty -= complaint.amount;
            });
            return maxComplaintQty;
        },
        complaintClosed() {
            return this?.clientComplaint?.closed;
        },
    },
    methods: {
        setUps() {
            this.form.ups = [];
            for (let i = 0; i < this.form.labels; i++) {
                this.form.ups.push(
                    {
                        'height': null,
                        'width': null,
                        'length': null,
                        'weight': null,
                    }
                );
            }
        },
        submit() {
            if (this.clientComplaint) {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .patch(this.$$route('ask-for-quote.order-information.client-complaint.patch', {
                        'askForQuote': this.askForQuote.id,
                        'clientComplaint': this.clientComplaint.id
                    }), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            } else {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .post(this.$$route('ask-for-quote.order-information.client-complaint', {
                        'askForQuote': this.askForQuote.id
                    }), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            }

        },
        submitComplaintBill() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                    complaint_bill: this.form.complaint_bill ? 'true' : '',
                }))
                .post(this.$$route('ask-for-quote.order-information.client-complaint.complaint-bill.post', {
                    'askForQuote': this.askForQuote.id,
                    'clientComplaint': this.clientComplaint.id
                }), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        },
        closeComplaint() {
            this.form.closed = true;
            this.submit();
        },
    },
};
</script>
